import { useCallback, useEffect, useRef, useState } from "react";
import type { Reading } from "./plc-bench-reading";
import { readPlcBench } from "./plc-bench-gateway";

export function usePlcBenchWorkspace() {
const [reading, setReading] = useState<Reading | null>(null);
const [error, setError] = useState("");
const [changedAt, setChangedAt] = useState<string | null>(null);
const lastValue = useRef<number | null>(null);
const pending = useRef(false);
const mounted = useRef(false);
const generation = useRef(0);
const refresh = useCallback(async () => {
    if (pending.current || !mounted.current) return;
    pending.current = true;
    const token = generation.current;
    try {
      const payload = await readPlcBench();
      if (!mounted.current || token !== generation.current) return;
      if (payload.status === "GOOD" && payload.value !== null) {
        if (lastValue.current !== null && payload.value !== lastValue.current) setChangedAt(payload.measuredAt);
        lastValue.current = payload.value;
      }
      setReading(payload);
      setError("");
    } catch (cause) {
      if (!mounted.current || token !== generation.current) return;
      setReading(null);
      setError(cause instanceof Error ? cause.message : "PLC okuması alınamadı.");
    } finally {
      if (token === generation.current) pending.current = false;
    }
  }, []);
useEffect(() => {
    mounted.current = true;
    generation.current++;
    void refresh();
    const timer = window.setInterval(() => void refresh(), 2000);
    return () => { mounted.current = false; generation.current++; pending.current = false; window.clearInterval(timer); };
  }, [refresh]);
return { reading, error, changedAt, refresh };
}
